import { SHORTENER_TYPE } from "src/app/core/constants/common";

export const SchedulerFormControlConstant = {
  CAMPAIGN_CODE: 'campaignCode',
  SEGMENT_CODE: 'segmentCode',
  START_END_DATE: 'campaignStartEndDate',
  CHANNEL: 'channel',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  START_TIME: 'startTime',
  END_TIME: 'endTime',
  TRACK_URL: 'urlClickTrack',
  WABA_NUMBER: 'wabaNumber',
  WABA_CODE: 'wabaCode',
  PRIMARY_CHANNEL: 'primaryChannel',
  SECONDARY_CHANNEL: 'secondaryChannel',
  CHANNEL_WAIT_TIME: 'channelWaitTime',
  LINK_WAIT_TIME: 'linkWaitTime',
  MODE_OF_EXECUTION: 'modeOfExecution',
  END_DATE_TYPE: 'endDateType',
  AGENT_NUMBER: 'agentNumber',
  SENDER_EMAIL: 'emailSenderId',
  CHANNEL_SEQUENCE: 'channelSequence',
  LINK_WAIT_TIME_ENABLED: 'linkWaitTimeEnabled',
  SHORTENER_PROVIDER: 'shortenerProvider',
};

export const UrlTrackOptions = {
  YES: 'Yes',
  NO: 'No',
};

export const ANALYTIC_VIEW_TYPE = {
  ONE_TIME_SINGLE_CHANNEL: 'ONE_TIME_SINGLE_CHANNEL',
  ONE_TIME_CUMULATIVE: 'ONE_TIME_CUMULATIVE',
  RECURRING_SINGLE_CHANNEL: 'RECURRING_SINGLE_CHANNEL',
  RECURRING_CUMULATIVE: 'RECURRING_CUMULATIVE',
};

export const CHART_TYPE = {
  BAR: 'bar',
  DONUT: 'donut',
  LOLLIPOP: 'lollipop',
  STACKED_BAR: 'stackedBar',
  HEATMAP: 'heatmap',
  DOUBLE_DONUT: 'doubleDonut',
  LINE: 'line',
  MULTI_LINE: 'multiLine',
};

export const CampaignStatus = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  EXECUTED: 'Executed',
  CANCELLED: 'Cancelled',
  UNSCHEDULING_FAILED: 'Unscheduling Failed',
  FAILED: 'Failed',
};

export const TEMPLATE_TYPE = {
  SMS: 'SMS',
  WHATSAPP: 'WhatsApp',
  RCS: 'RCS',
  EMAIL: 'Email',
  PUSH: 'Push Notification',
  FORM: 'FORM',
};

export const TEMPLATE_TYPE_MAP = {
  SMS: 'SMS',
  WHATSAPP: 'WhatsApp',
  RCS: 'RCS',
  EMAIL: 'Email',
  PUSH_NOTIFICATION: 'Push Notification',
  FORM: 'FORM',
};

export const ERROR_COLORS = [
  '#e6194b',
  '#3cb44b',
  '#ffe119',
  '#4363d8',
  '#f58231',
  '#911eb4',
  '#46f0f0',
  '#f032e6',
  '#bcf60c',
  '#fabebe',
  '#008080',
  '#e6beff',
  '#9a6324',
  '#fffac8',
  '#800000',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#000075',
];
